module.exports = __webpack_public_path__ + "img/accept.da63349e.svg";